import type { Customer } from "../Customer.js";
import { CustomerType } from "../CustomerType.js";
import { PricingLevel } from "../PricingLevel.js";

export function getCustomerType(
	customer: Pick<Customer, "pricingLevel" | "isCustomerB2f"> | null | undefined,
): CustomerType {
	const { pricingLevel = PricingLevel.B2c, isCustomerB2f } = customer ?? {};
	if (pricingLevel === PricingLevel.B2c) {
		return CustomerType.B2c;
	}
	if (isCustomerB2f) {
		return CustomerType.B2f;
	}
	return CustomerType.B2b;
}
